import { supabase } from '@/integrations/supabase/client';

/** Marks profile onboarding as done (reaching or completing step 3). */
export async function markOptionalFieldsCompleted(username: string): Promise<void> {
  try {
    await supabase
      .from('profiles')
      .update({ optional_fields_completed: true })
      .eq('username', username);
  } catch {
    /* non-blocking */
  }
}
